// import React from "react";
// import { Link } from "react-router-dom";

// function ThankYou() {
//   return (
//     <>
//       <div className="container text-center py-5 min-vh-100">
//         <div className="row d-flex justify-content-center align-items-center h-100">
//           <div className="col-9 col-md-8 col-lg-6 col-xl-4">
//             <div
//               className="card mt-5 shadow-lg"
//               style={{
//                 maxWidth: "48rem",
//                 backgroundColor: "#38E54D",
//                 borderRadius: "15px",
//               }}
//             >
//               <i
//                 className="fa-solid fa-circle-check fa-4x text-dark mt-5"
//                 style={{ fontSize: "4rem" }}
//               ></i>

//               <div className="card-body text-center">
//                 <h3 className="card-text">Thank You!</h3>

//                 <Link
//                   className="btn btn-dark mx-auto px-4 mt-3 ms-2 mb-3"
//                   to="/"
//                   style={{
//                     borderRadius: "50px",
//                     backgroundColor: "#343a40",
//                     borderColor: "#343a40",
//                     boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
//                   }}
//                 >
//                   OK
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ThankYou;

import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const ThankYou = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setTimeout(() => setFadeIn(true), 200);
  }, []);

  return (
    <div className="container text-center py-5 min-vh-100 d-flex justify-content-center align-items-center">
      <div
        className={`card shadow-lg p-4 text-center ${fadeIn ? "fade-in" : ""}`}
        style={{
          maxWidth: "28rem",
          backgroundColor: "#38E54D",
          borderRadius: "15px",
          transition: "opacity 0.8s ease-in-out",
          opacity: fadeIn ? 1 : 0,
        }}
      >
        <i
          className="fa-solid fa-circle-check text-dark"
          style={{ fontSize: "4rem", marginBottom: "15px" }}
        ></i>

        <h3 className="fw-bold">Signup Successful!</h3>
        {/* <p className="text-dark mt-2">
          Your account has been created. Please log in to continue.
        </p> */}
        <p className="text-danger mt-2">
          Your account has been created and is pending approval. You will be
          able to log in once your account is approved.
        </p>

        <div className="d-flex justify-content-center gap-3 mt-3">
          <Link
            to="/login"
            className="btn btn-dark px-4"
            style={{
              borderRadius: "50px",
              backgroundColor: "#343a40",
              borderColor: "#343a40",
              boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          >
            Login
          </Link>

          <Link
            to="/"
            className="btn btn-outline-dark px-4"
            style={{
              borderRadius: "50px",
              transition: "all 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          >
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
